module.exports = __webpack_public_path__ + "static/media/20231026-DSC_5210.4f7d5204.jpg";